/**
 * @author Akshay Kumar Singh
 * @file CreateUser Modal
 * @flow
 */
import React, { useState, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import Validator from '../../shared/validator'
import AlertModal from './AlertModal';
import { spinnerService } from '../services/spinner.service';
import { CallApi } from '../services/api.service';
import { useHistory } from "react-router-dom";
import CONFIG from '../../configuration/config'
import { USER_ROLES, LABLES, STRINGS } from '../constants/data';

const CreateUserModal = ({ isModalOpen, closeModal, getUserDataList, plantArr }) => {

  const history = useHistory()
  const [, forceUpdate] = useState();

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    plantId: '',
    status: 0,
    roleArr: [
      { id: 1, value: USER_ROLES.AuditManager },
      { id: 2, value: USER_ROLES.Auditor },
      { id: 3, value: USER_ROLES.Reviewer },
      { id: 4, value: USER_ROLES.PlantManager },
      { id: 5, value: USER_ROLES.PlantAuditor },
      { id: 6, value: USER_ROLES.PlantReviewer }
    ]
  });

  useEffect(() => {
    Validator.hideMessages();
  }, [])

  /**
   * @description This function hides validation messages and closes create user modal.
   */
  const handleModal = (event) => {
    event.preventDefault();
    Validator.hideMessages();
    closeModal();
  }

  /**
   * @description This function sets value of state variables
   */
  const handleChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value
    });
  }

  /**
   * @description This function submits user details and creates new user.
   */
  const onSubmit = (event) => {
    event.preventDefault();
    const { firstName, lastName, email, role, status, plantId } = state;
    let roleCheck = (role == USER_ROLES.AuditManager || role == USER_ROLES.Auditor || role == USER_ROLES.Reviewer)
    let isValid = roleCheck ? (Validator.fieldValid('firstName') && Validator.fieldValid('lastName') &&
      Validator.fieldValid('email') && Validator.fieldValid('role') && (Validator.fieldValid('status') === false)) :
      Validator.allValid();
    if (isValid) {
      handleModal(event);
      const newUserObj = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        role_name: role,
        is_active: status,
        plant_id: plantId
      }

      spinnerService.show(LABLES.Oval, STRINGS.CreateNewUser);
      CallApi(LABLES.POST, CONFIG.createUser, {}, newUserObj, '', createUser, history);
    } else {
      Validator.showMessages();
      forceUpdate({})
      AlertModal.showAlert(STRINGS.AllFieldRequired);
    }
  }

  /**
 * @description createUser API callback function
 * @param response This is the response structure received from API
 */
  const createUser = (response) => {
    if (response.success) {
      AlertModal.showAlert(response.message);
      setTimeout(() => {
        getUserDataList()
      }, 2000);
    }
  }

  return (
    <Modal open={isModalOpen} onClose={handleModal} center>
      <div className="pop-up-bg" id="create-audit-popup">
        <div className="rqst-accs-popup">
          <div className="create-audit-outer">
            <div className="top-cntnt">
              <h4> {LABLES.CreateUser} </h4>
              <a href="" onClick={handleModal}>
                <img src={require("../../assets/images/cross-icon.png")} alt="cross-icon" />
              </a>
            </div>
          </div>
          <div className="form-cntnt">
            <form action="" onSubmit={onSubmit}>
              <div className="form-row">
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.FirstName}</label>
                    <input
                      className={"form-control " + (Validator.message('firstName', state.firstName, 'firstName') ? 'error' : '')}
                      type="text"
                      name="firstName"
                      onKeyPress={() => Validator.showMessageFor('firstName')}
                      placeholder='First name'
                      onChange={handleChange}
                    />
                    <div className='srv-validation-message'>{Validator.message('firstName', state.firstName, 'firstName')}</div>
                  </div>
                </div>
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.LastName}</label>
                    <input
                      className={"form-control " + (Validator.message('lastName', state.lastName, 'lastName') ? 'error' : '')}
                      type="text"
                      name="lastName"
                      onKeyPress={() => Validator.showMessageFor('lastName')}
                      placeholder='Last name'
                      onChange={handleChange}
                    />
                    <div className='srv-validation-message'>{Validator.message('lastName', state.lastName, 'lastName')}</div>
                  </div>
                </div>
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.EmailAddress}</label>
                    <input
                      className={"form-control " + (Validator.message('email', state.email, 'email') ? 'error' : '')}
                      type="text"
                      name="email"
                      onKeyPress={() => Validator.showMessageFor('email')}
                      placeholder='example@niagarawater.com'
                      onChange={handleChange}
                    />
                    <div className='srv-validation-message'>{Validator.message('email', state.email, 'email')}</div>
                  </div>
                </div>
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.Role}</label>
                    <select
                      className={"form-control " + (Validator.message('role', state.role, 'role') ? 'error' : '')}
                      onChange={handleChange} defaultValue='' name='role'
                      style={{ textTransform: 'capitalize' }}
                      onKeyPress={() => Validator.showMessageFor('role')}>
                      <option hidden value=''>{STRINGS.SelectRole}</option>
                      {state.roleArr.map((data, index) => {
                        return (
                          <option key={data.id} value={data.value}>
                            {data.value}
                          </option>
                        )
                      })}
                    </select>
                    <div className='srv-validation-message'>{Validator.message('role', state.role, 'role')}</div>
                  </div>
                </div>
                {(state.role === USER_ROLES.PlantManager || state.role === USER_ROLES.PlantAuditor || state.role === USER_ROLES.PlantReviewer) &&
                  <div className="column-three">
                    <div className="form-group">
                      <label htmlFor="">{LABLES.Plant}</label>
                      <select
                        className={"form-control " + (Validator.message('plantId', state.plantId, 'plantId') ? 'error' : '')}
                        onChange={handleChange} defaultValue='' name='plantId'
                        style={{ textTransform: 'capitalize' }}
                        onKeyPress={() => { Validator.showMessageFor('plantId') }}>
                        <option hidden value=''>{STRINGS.SelectPlant}</option>
                        {plantArr.map((data, index) => {
                          return (
                            <option key={data.plant_id} value={data.plant_id}>
                              {data.plant_name}
                            </option>
                          )
                        })}
                      </select>
                      {(state.role === USER_ROLES.PlantManager || state.role === USER_ROLES.PlantAuditor || state.role === USER_ROLES.PlantReviewer) &&
                        <div className='srv-validation-message'>{Validator.message('plantId', state.plantId, 'plantId')}</div>
                      }
                    </div>
                  </div>}
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.Status}</label>
                    <div className="group-radio-btn">
                      <input type="radio" id="Active" name='status' value={0} onChange={handleChange} defaultChecked />
                      <label htmlFor="Active">{LABLES.Active}</label>
                      <input type="radio" id="In-Active" name='status' value={2} onChange={handleChange} />
                      <label htmlFor="In-Active">{LABLES.InActive}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="crt-odi-btn-otr">
                <button className="btn-prmry" type="submit" style={{ backgroundColor: '#005daa' }}
                > {LABLES.CreateUser}
                  </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default CreateUserModal;